/*
    Requires a child component to send and event up
    See mobile menu as a basic example
    Wll then have to add the listener in

    On rendering, also need to include the drawerHeader snippet which will then allow the drawer to close

*/

import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { DrawerHeader } from './DrawerHeader';
import { MobileMenu } from '../MobileMenu/MobileMenu';

@Component
export class DrawerContainer extends ThemeComponent {
    @Ref drawerHeader!: DrawerHeader;
    @Ref({ required: false }) drawerContent!: MobileMenu;

    private focusableElements =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    private previousFocus: Element = document.body;

    /** Initialise component */
    init() {
        this.setAttribute('aria-hidden', 'true');
        this.$subscribe(this.drawerHeader.onCloseChange, this.toggleClose.bind(this));
        if (this.drawerContent) {
            this.$subscribe(this.drawerContent.onOpenChange, this.toggleOpen.bind(this));
        }
    }

    /** Handle focus lock */
    handleFocusLock() {
        const firstFocusableElement = this.querySelectorAll(this.focusableElements)[0] as HTMLElement;
        const focusableContent = this.querySelectorAll(this.focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1] as HTMLElement;
        this.$log.info(JSON.stringify(lastFocusableElement.classList));

        document.addEventListener('keydown', (e) => {
            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) { // if shift key pressed for shift + tab combination
                if (document.activeElement === firstFocusableElement) {
                    e.preventDefault();
                    lastFocusableElement.focus(); // add focus for the last focusable element
                }
            } else { // if tab key is pressed
                if (firstFocusableElement === lastFocusableElement) {
                    e.preventDefault();
                    firstFocusableElement.focus();
                }

                if (document.activeElement === lastFocusableElement) {
                    e.preventDefault();
                    firstFocusableElement.focus();
                }
            }
        });

        setTimeout(()=> {
            firstFocusableElement.focus();
        }, 300);
    }

    /** Toggle drawer open */
    toggleOpen() {
        if (document.activeElement) {
            this.previousFocus = document.activeElement;
        }

        document.body.classList.add('drawer-open');
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        this.handleFocusLock();
    }

    /** Toggle drawer close */
    toggleClose() {
        const previous = this.previousFocus as HTMLElement;

        document.body.classList.remove('drawer-open');
        this.removeAttribute('open');
        this.setAttribute('aria-hidden', 'true');
        previous.focus();
    }
}
